import PortfolioTabs from './PortfolioTabs';

export default PortfolioTabs;
